/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import React from 'react';
import InfiniteLoader from 'react-window-infinite-loader';
import {FixedSizeList} from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import PropTypes from "prop-types";

export default class LoadableList extends React.Component {
    isLoaded = (index) => !this.props.hasMore || index < this.props.items.length;

    render = () => {
        const {items, hasMore, onLoadMore, isLoadingMore, renderRow, itemSize} = this.props;
        const itemCount = hasMore ? items.length + 1 : items.length;
        const _onLoadMore = isLoadingMore ? () => {} : onLoadMore;
        return (
            <AutoSizer>
                {({height, width}) => (
                    <InfiniteLoader isItemLoaded={this.isLoaded} itemCount={itemCount} loadMoreItems={_onLoadMore}>
                        {({onItemsRendered, ref}) => (
                            <FixedSizeList width={width} height={height} itemCount={items.length} ref={ref}
                                           onItemsRendered={onItemsRendered} itemSize={itemSize}>
                                {renderRow}
                            </FixedSizeList>
                        )}
                    </InfiniteLoader>
                )}
            </AutoSizer>
        )
    }
}

LoadableList.propTypes = {
    items: PropTypes.arrayOf,
    hasMore: PropTypes.bool,
    onLoadMore: PropTypes.func,
    isLoadingMore: PropTypes.bool,
    renderRow: PropTypes.func,
    itemSize: PropTypes.number
};